module.exports = __webpack_public_path__ + "static/media/price-tag.475b9ef5.svg";